import type { FC } from 'react';
import React from 'react';
import cx from 'classnames';
import { Hyperlink } from '@THC/components/Hyperlink';

import { VideoPoster } from 'Components/StaticPages/ProductPageComponents/VideoPoster/VideoPoster';

import { useVideoModal } from './VideoModal/useVideoModal';
import { VideoModal } from './VideoModal/VideoModal';
import { TestimonialsCarousel } from './TestimonialsCarousel';

import styles from './FAQSection.module.scss';

const YOUTUBE_VIDEO_ID = '9EOfeog8YMg';

export const FAQSection: FC = () => {
	const { closeModal: closeVideoModal, openModal: onOpenVideoModal, state: isVideoModalOpen } = useVideoModal();

	return (
		<>
			<section className={styles.faq}>
				<div className={styles.col}>
					<div className={cx(styles.faqItem, styles.faqItemVideo)}>
						<VideoPoster
							alt="Play Motorway Move introduction video"
							onClick={onOpenVideoModal}
							youtubeVideoId={YOUTUBE_VIDEO_ID}
						/>
						<div className={styles.text}>
							<h3>Transport built for business</h3>
							<p>
								Get stock delivered from anywhere in the UK to your forecourt, fast. We handle the logistics, appraisals
								and admin. You can do what you do best.
							</p>
						</div>
					</div>
					<TestimonialsCarousel className={cx(styles.faqItem, styles.testimonials)} />
				</div>
				<div className={styles.col}>
					<div className={cx(styles.faqItem, styles.text)}>
						<h3>So, how much does it cost? </h3>
						<p>
							Motorway Move is £99 for the first 50 miles, plus £0.95 per mile after that. No hidden fees, full
							coverage, total peace of mind.
						</p>
						<p>This all-inclusive fee covers:</p>
						<ul>
							<li>Collection & delivery</li>
							<li>Comprehensive vehicle appraisal</li>
							<li>All fuel & toll costs</li>
							<li>75 minutes of on-site time</li>
							<li>Breakdown recovery</li>
							<li>50% coverage if the seller doesn’t proceed, or should you not, in the event of additional damage</li>
						</ul>
						<p>
							Want more pricing details?{' '}
							<Hyperlink as="a" href="https://pro.motorway.co.uk/pricing" label="Click here" />.
						</p>
					</div>
					<div className={cx(styles.faqItem, styles.text)}>
						<h3>Need help?</h3>
						<p>
							You’re in good hands with our Move team – logistics pros who take full liability from collection to
							forecourt.
						</p>
						<p>
							Reach out any time at{' '}
							<Hyperlink as="a" href="mailto:dealersupport@motorway.co.uk" label="dealersupport@motorway.co.uk" /> or
							talk with us on <Hyperlink as="a" href="tel:0203 988 4396" label="0203 988 4396" /> during working hours.
						</p>
					</div>
				</div>
			</section>
			{isVideoModalOpen && <VideoModal dismissModal={closeVideoModal} youtubeVideoId={YOUTUBE_VIDEO_ID} />}
		</>
	);
};
